import { render } from "./SupplierDetailHistoryTab.vue?vue&type=template&id=2d26c674"
import script from "./SupplierDetailHistoryTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__